import Vue from 'vue'
import VueShortkey from 'vue-shortkey'

Vue.use(VueShortkey)
